__turbopack_context__.v({
  "btn-share": "fhKpfq_btn-share",
  "container-share": "fhKpfq_container-share",
  "nameSosmed": "fhKpfq_nameSosmed",
  "socmed-icon": "fhKpfq_socmed-icon",
  "title": "fhKpfq_title",
});
